'use strict';

import React, { Component } from 'react'

import _ from 'lodash'

import { CSSTransition, TransitionGroup } from 'react-transition-group'

import Layout       from '@Layout/BackOffice'
import CreationForm from '@/Form/CreationForm'

import _config from '@Config/Catalog/show_product'

const { app } = window;

const config = _.cloneDeep(_config);

delete config.fields.send_notifications;

export default class NewTicketPage extends Component
{
	UNSAFE_componentWillMount ()
	{
		app.resetFunctions();
	}

	render ()
	{
		const props = this.props;

		var output =
		(
			<Layout page_title="Nouveau billet" history={ props.history }>

				<div className="page-content">

					<div className="o-content">

						<TransitionGroup className="u-full-width">

							<CSSTransition
								classNames="a-form-transition"
								appear={ true }
								enter={ true }
								exit={ true }
								timeout={{ enter: 240, exit: 320, appear: 500 }}>

								<CreationForm config={ config } />

							</CSSTransition>

						</TransitionGroup>

					</div>

				</div>

			</Layout>
		);

		return output;
	}
}